import {
  FaLink, FaAlignLeft, FaPhone, FaSms, FaEnvelope, FaWhatsapp, 
  FaMapMarkerAlt, FaWifi, FaCalendarAlt, FaAddressCard, 
  FaInstagram, FaFacebook, FaLinkedin
} from 'react-icons/fa';

// Simplified LINK_TYPES to only show Website as requested, but labeled broadly
export const LINK_TYPES = [
  { id: 'url', label: 'Website / Social', icon: FaLink, color: 'text-blue-500' },
  // Hidden for now, to be added back one by one:
  // { id: 'text', label: 'Text', icon: FaAlignLeft, color: 'text-zinc-400' },
  // { id: 'phone', label: 'Phone', icon: FaPhone, color: 'text-green-500' },
  // { id: 'sms', label: 'SMS', icon: FaSms, color: 'text-yellow-500' },
  // { id: 'email', label: 'Email', icon: FaEnvelope, color: 'text-red-500' },
  // { id: 'whatsapp', label: 'WhatsApp', icon: FaWhatsapp, color: 'text-green-500' },
  // { id: 'location', label: 'Location', icon: FaMapMarkerAlt, color: 'text-red-500' },
  // { id: 'wifi', label: 'WiFi', icon: FaWifi, color: 'text-blue-400' },
  // { id: 'event', label: 'Event', icon: FaCalendarAlt, color: 'text-purple-500' },
  // { id: 'vcard', label: 'Contact', icon: FaAddressCard, color: 'text-orange-500' },
  // { id: 'instagram', label: 'Instagram', icon: FaInstagram, color: 'text-pink-500' },
  // { id: 'facebook', label: 'Facebook', icon: FaFacebook, color: 'text-blue-600' },
  // { id: 'linkedin', label: 'LinkedIn', icon: FaLinkedin, color: 'text-blue-700' },
];

export const parseUrl = (url) => {
  if (!url) return { type: 'url', data: { url: '' } };
  
  // Logic preserved for backward compatibility if needed, but UI will primarily use 'url'
  if (url.startsWith('text:')) return { type: 'text', data: { text: url.substring(5) } };
  if (url.startsWith('tel:')) return { type: 'phone', data: { phone: url.substring(4) } };
  if (url.startsWith('sms:')) {
    const [num, body] = url.substring(4).split('?body=');
    return { type: 'sms', data: { smsPhone: num, smsBody: decodeURIComponent(body || '') } };
  }
  if (url.startsWith('mailto:')) {
    const [email, query] = url.substring(7).split('?');
    const params = new URLSearchParams(query);
    return { type: 'email', data: { email, emailSubject: params.get('subject') || '', emailBody: params.get('body') || '' } };
  }
  if (url.includes('wa.me')) {
    try {
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split('/');
      const phone = pathParts[pathParts.length - 1];
      const text = urlObj.searchParams.get('text') || '';
      return { type: 'whatsapp', data: { waPhone: phone, waText: text } };
    } catch (e) {
      return { type: 'url', data: { url } };
    }
  }
  if (url.startsWith('WIFI:')) {
    const parts = url.split(';');
    const data = {};
    parts.forEach(p => {
      const [k, v] = p.split(':');
      if (k && v) data[k] = v;
    });
    return { type: 'wifi', data: { wifiSsid: data['S'] || '', wifiType: data['T'] || 'WPA', wifiPassword: data['P'] || '', wifiHidden: data['H'] === 'true' } };
  }
  
  if (url.includes('BEGIN:VCALENDAR')) {
    const getValue = (key) => {
      const regex = new RegExp(`${key}:(.*)`);
      const match = url.match(regex);
      return match ? match[1].trim() : '';
    };

    const formatToInput = (icsDate) => {
      if (!icsDate || icsDate.length < 13) return '';
      try {
        const y = icsDate.substring(0, 4);
        const m = icsDate.substring(4, 6);
        const d = icsDate.substring(6, 8);
        const t = icsDate.substring(9, 11);
        const min = icsDate.substring(11, 13);
        const date = new Date(Date.UTC(y, m - 1, d, t, min));
        const pad = n => n < 10 ? '0' + n : n;
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
      } catch (e) { return ''; }
    };

    return {
      type: 'event',
      data: {
        eventTitle: getValue('SUMMARY'),
        eventLocation: getValue('LOCATION'),
        eventDesc: getValue('DESCRIPTION'),
        eventStart: formatToInput(getValue('DTSTART')),
        eventEnd: formatToInput(getValue('DTEND')),
      }
    };
  }
  
  if (url.includes('BEGIN:VCARD')) {
     const getValue = (key) => {
        const regex = new RegExp(`${key}.*:(.*)`);
        const match = url.match(regex);
        return match ? match[1].trim() : '';
     };
     const nParts = getValue('N').split(';');
     return {
        type: 'vcard',
        data: {
            vLn: nParts[0] || '',
            vFn: nParts[1] || '',
            vPhone: getValue('TEL;TYPE=CELL'),
            vEmail: getValue('EMAIL;TYPE=WORK'),
            vOrg: getValue('ORG'),
            vUrl: getValue('URL'),
            vAddr: getValue('ADR;TYPE=WORK').split(';')[2] || ''
        }
     };
  }
  
  if (url.includes('instagram.com')) return { type: 'instagram', data: { url } };
  if (url.includes('facebook.com')) return { type: 'facebook', data: { url } };
  if (url.includes('linkedin.com')) return { type: 'linkedin', data: { url } };

  return { type: 'url', data: { url } };
};

export const buildUrl = (type, data) => {
  const validate = (u) => {
    if (!u) return '';
    let final = u.trim();
    if (!final.startsWith('http://') && !final.startsWith('https://')) final = 'https://' + final;
    return final;
  };

  switch (type) {
    case 'url': return validate(data.url);
    case 'instagram': return validate(data.url);
    case 'facebook': return validate(data.url);
    case 'linkedin': return validate(data.url);
    case 'text': return `text:${data.text}`;
    case 'phone': return `tel:${data.phone?.replace(/\s/g, '')}`;
    case 'sms': return `sms:${data.smsPhone?.replace(/\s/g, '')}?body=${encodeURIComponent(data.smsBody || '')}`;
    case 'email': return `mailto:${data.email}?subject=${encodeURIComponent(data.emailSubject || '')}&body=${encodeURIComponent(data.emailBody || '')}`;
    case 'whatsapp': return `https://wa.me/${data.waPhone?.replace(/\D/g, '')}?text=${encodeURIComponent(data.waText || '')}`;
    case 'location': return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(data.locationQuery || '')}`;
    case 'wifi': return `WIFI:S:${data.wifiSsid};T:${data.wifiType};P:${data.wifiPassword};H:${data.wifiHidden};;`;
    case 'vcard': return `BEGIN:VCARD\nVERSION:3.0\nN:${data.vLn};${data.vFn};;;\nFN:${data.vFn} ${data.vLn}\nTEL;TYPE=CELL:${data.vPhone}\nEMAIL;TYPE=WORK:${data.vEmail}\nORG:${data.vOrg}\nURL:${data.vUrl}\nADR;TYPE=WORK:;;${data.vAddr};;;;\nEND:VCARD`;
    case 'event': 
      const formatDate = (d) => d ? new Date(d).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z' : '';
      let eventStr = 'BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT';
      if (data.eventTitle) eventStr += `\nSUMMARY:${data.eventTitle}`;
      if (data.eventStart) eventStr += `\nDTSTART:${formatDate(data.eventStart)}`;
      if (data.eventEnd) eventStr += `\nDTEND:${formatDate(data.eventEnd)}`;
      if (data.eventLocation) eventStr += `\nLOCATION:${data.eventLocation}`;
      if (data.eventDesc) eventStr += `\nDESCRIPTION:${data.eventDesc}`;
      eventStr += '\nEND:VEVENT\nEND:VCALENDAR';
      return eventStr;
    default: return '';
  }
};